import { useEffect, useState } from "react"
import Component, { InputDateProps } from "src/shared/components/forms/input-date/InputDate"
import { useDate } from "src/shared/hooks/useDate"
import { addDays } from "src/shared/helpers/addDays"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { substractDays } from "src/shared/helpers/substractDays"

interface Props extends Omit<InputDateProps, "onReset" | "onChange"> {
    onChange: (v: Date[]) => void
}

export function InputDate({ value, onChange, ...props }: Props) {
    const [fieldValue, onFieldChange] = useState<Date[]>([])
    const { areSameDay, setHHMMSS } = useDate()

    const { nowHotel } = useFormatDate()

    useEffect(() => {
        const first_date = value?.[0]?.getDate() || 0
        const seconf_date = value?.[1]?.getDate() || 0

        const local_first_date = fieldValue?.[0]?.getDate() || 0
        const local_seconf_date = fieldValue?.[1]?.getDate() || 0

        if (first_date !== local_first_date || seconf_date !== local_seconf_date) {
            onFieldChange(value.filter((v) => v))
        }
    }, [value])

    const handleConfirm = () => {
        if (!fieldValue.length) return
        onChange(fieldValue)
    }

    return (
        <Component
            modalClosableOnClickOutside={false}
            placeholder="Selecciona una fecha"
            label="Fecha de entrada y salida"
            inputClassName="venta-habitacion-input"
            isRange={true}
            onReset={() => {
                onFieldChange([
                    setHHMMSS({
                        startDate: nowHotel,
                        newHour: "00:00:00",
                        isNewHourInUTC: false,
                    }),
                    addDays({
                        date: setHHMMSS({
                            startDate: nowHotel,
                            newHour: "00:00:00",
                            isNewHourInUTC: false,
                        }),
                        days: 1
                    })
                ])
            }}
            value={fieldValue}
            disabledBeforeOrEqualDate={substractDays({
                date: nowHotel,
                days: 1,
            })}
            disabledAfterOrEqualDate={
                !fieldValue.length
                    ? nowHotel
                    : fieldValue.length === 2 && fieldValue[1] === fieldValue[2]
                        ? fieldValue[1]
                        : fieldValue.length === 2
                            ? addDays({ date: fieldValue[1], days: 1 })
                            : undefined
            }
            onChangeDblClick={(date) => {
                onFieldChange([date, date])
            }}
            onChange={(date) => {

                if (fieldValue.length === 0) {
                    onFieldChange([date])
                    return
                }
                if (date <= fieldValue[0]) {
                    onFieldChange([date])
                    return
                }
                if (fieldValue?.length === 2 && areSameDay(nowHotel, date)) {
                    onFieldChange([date])
                    return
                }
                if (fieldValue?.length === 2) {
                    onFieldChange([])
                    return
                }
                onFieldChange([fieldValue[0], date])
            }}
            onConfirm={handleConfirm}
            {...props}
        />
    )
}